import { createFileRoute } from '@tanstack/react-router'
import { InstitutionProfilePage } from '@/pages/profile/institution-profile/ui/InstitutionProfilePage'

export const Route = createFileRoute('/institution-profile')({ component: InstitutionProfilePage })
